import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import Button from "../Button/Button";
import './duduElement.scss';
import { useMediaQuery } from "react-responsive";


export default function DuduElement() {
    const isMediumScreen = useMediaQuery({ query: '(max-width: 850px)' });
    const isAlmostMediumScreen = useMediaQuery({ query: '(max-width: 1212px)' });

    const coreServiceArray = [
        "ENTERTAINMENT EVENTS",
        "CORPORATE EVENTS",
        "CELEBRATORY EVENTS",
        "DECORATION DESIGNS",
        "PODCAST",
    ];

    const imageMap = {
        "ENTERTAINMENT EVENTS": "https://res.cloudinary.com/dqgtosjsg/image/upload/v1737640131/entertainmentEvent_b0fpda.jpg",
        "CORPORATE EVENTS": "https://res.cloudinary.com/dqgtosjsg/image/upload/v1737640129/corporateEvent_mtrdgv.jpg",
        "CELEBRATORY EVENTS": "https://res.cloudinary.com/dqgtosjsg/image/upload/v1740772154/AdunTemi-1572_whgirc.jpg",
        "DECORATION DESIGNS": "https://res.cloudinary.com/dqgtosjsg/image/upload/v1740771442/MAASFILE-6_l8xrrz.jpg",
        "PODCAST": "https://res.cloudinary.com/dqgtosjsg/image/upload/v1737640170/podcast_egtjug.jpg",
    };

    const [coreSer, setCoreSer] = useState(coreServiceArray[0]);
    const [currentImage, setCurrentImage] = useState(imageMap[coreServiceArray[0]]);
    const imageRef = useRef(null);
    // const textRef = useRef(null);
    const handleChangeService = (newCoreService) => {
        if (newCoreService === coreSer) return;

        const tl = gsap.timeline();

        tl.to([imageRef.current], {
            opacity: 0,
            x: -100,
            duration: 0.5,
            ease: "power2.inOut",
            onComplete: () => {
                setCoreSer(newCoreService);
                setCurrentImage(imageMap[newCoreService]);
            },
        });

        tl.to([imageRef.current], {
            opacity: 1,
            x: 0,
            duration: 0.5,
            ease: "power2.inOut",
        });
    };

    useEffect(() => {
    
        let tlText2 = gsap.timeline({
            scrollTrigger: {
                trigger: '.core-services',
                toggleActions: "restart none none reset",
                // markers: true,
                scrub: true,
                start: "20% center",
                end: "45% center",
            }
        });
    
        tlText2.to(".revelation3", {
            duration: .7,
            opacity: 1,
            ease: "power1.out",
            y: 0,
            height: 'fit-content',
            stagger: {
                amount: 0.3
            }
        });
    
    }, [coreSer]);



    return (

        <div className="core-services" style={{ display: 'flex', justifyContent: "space-between", gap: isAlmostMediumScreen ? '100px' : '200px', color: '#916859', marginBottom: '100px', flexWrap: isMediumScreen ? 'wrap' : 'nowrap' }}>
            <div className="core-services--cont1" style={{ flex: 1, display: 'flex', justifyContent: "space-between", alignItems: 'start', flexDirection: 'column', }}>
                <div style={{ flexDirection: 'column', display: 'flex' }}>
                    <div className="core-services--cont11" style={{ display: 'flex', width: 'fit-content', justifyContent: "space-between", alignItems: 'center', gap: '8px', flexWrap: 'nowrap', marginBottom: isMediumScreen ? '50px' : 0, }}>
                        <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#916859' }}></div>
                        <p className="revelation3" style={{ fontSize: '14px', lineHeight: "5px", fontWeight: 400, }}>OUR CORE SERVICES</p>
                    </div>
                    {isMediumScreen &&
                        <div>
                            <p className="core-services--cont12" style={{ marginBottom: '50px', width: '100%' }}>
                                We offer a comprehensive range of,
                                <span style={{ fontStyle: 'italic' }}> services to our clients.</span>
                            </p>
                            <p style={{ width: '100%', marginBottom: '50px', fontSize: '20px', lineHeight: '30px',  }}>
                                Whether you're hosting an intimate gathering or a large-scale celebration,
                                our team is here to assist you every step of the way. Our core services include:
                            </p>
                        </div>
                    }
                </div>

                <div
                    style={{
                        display: 'flex',
                        flex: 1,
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    <div
                        ref={imageRef}
                        className="image-container"
                        style={{
                            width: isMediumScreen ? "100%" : isAlmostMediumScreen ? '400px' : '535px',
                            height: isAlmostMediumScreen ? '400px' : '500px',
                            backgroundImage: `url(${currentImage})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            opacity: 1,
                            display: 'flex',
                            flex: 1,
                        }}
                        alt='Dudu world photos showcasing them in different events.'
                    />
                </div>
            </div>

            <div className="core-services--cont2" style={{ flex: 1, }}>
                {!isMediumScreen && <p className="revelation31 revelation3 core-services--cont12" style={{ marginBottom: '50px', width: '100%' }}>
                    We offer a comprehensive range of,
                    <span style={{ fontStyle: 'italic' }}> services to our clients.</span>
                </p>}
                {!isMediumScreen && <p className="revelation32 revelation3" style={{ width: '100%', marginBottom: '96px', fontSize: '20px', lineHeight: '30px',  }}>
                    Whether you're hosting an intimate gathering or a large-scale celebration,
                    our team is here to assist you every step of the way. Our core services include:
                </p>}
                <div style={{ width: '100%', display: 'flex', alignItems: 'start', flexDirection: 'column', marginBottom: '80px' }}>
                    {
                        coreServiceArray.map((core, index) => (
                            <div onClick={() => handleChangeService(core)} className="coreServiceArray" style={{ padding: isMediumScreen ? "20px 0" : '50px 0', width: '100%', cursor: 'pointer' }}>
                                <p style={{ opacity: coreSer === core ? 1 : .6, display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: isMediumScreen ? "20px" : isAlmostMediumScreen ? '24px' : '32px', }}><span style={{ marginRight: isAlmostMediumScreen ? '50px' : '73px' }}>0{index}</span><span style={{ fontWeight: 500, lineHeight: '28px', }}>{core}</span></p>
                            </div>
                        ))
                    }
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: isMediumScreen ? 'start' : 'end' }}>
                    <Button text={'Get in Touch'} route={'/contact'} />
                </div>
            </div>
        </div>
    );
}

